import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import ContentEngagementBarGraph from "../../components/ContentProviderDashboard/ContentEngagement";
import { generateClient } from "aws-amplify/api";
import { listUserProfiles } from "../../graphql/queries";
import AudienceByGender from "../../components/ContentProviderDashboard/AudienceByGenderChart";
import AudienceChart from "../../components/ContentProviderDashboard/AudienceChart";
import { Stack, Typography } from "@mui/material";
import ContentViewBarGraph from "../../components/ContentProviderDashboard/TotalViewsChart";
import AverageWatchTimeChart from "../../components/ContentProviderDashboard/AverageWatchTimeChart";
import EngagementRateChart from "../../components/ContentProviderDashboard/EngagementRateChart";
import Grid from "@mui/material/Grid";
import ContentApprovalTimeGraph from "../../components/ContentProviderDashboard/ContentApprovalTimeGraph";
import Button from "@mui/material/Button";

const Analytics = () => {
  const token = JSON.parse(localStorage.getItem("token") || "{}");
  const userId = token?.accessToken?.payload?.username;
  const navigate = useNavigate();
  const client = generateClient();
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await client.graphql({
          query: listUserProfiles,
          variables: {
            filter: {
              userId: {
                eq: userId,
              },
            },
          },
        });
        if (response?.data?.listUserProfiles?.items[0]?.id) {
          localStorage.setItem(
            "userProfileId",
            JSON.stringify({
              userProfileId: response?.data?.listUserProfiles?.items[0]?.id,
            })
          );
        } else {
          navigate("/user");
        }
      } catch (error) {}
    };
    fetchUserProfile();
  }, []);

  return (
    <div>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography my={2} variant="h4">
          Analytics
        </Typography>
      </Box>

      {/* <PaymentTable /> */}
      {/* <Box display={"flex"} gap={2}>
        <ContentReviewTable />
        <ContentInProgress />
        <ContentRetirementTable />
      </Box> */}
      <Stack gap={4}>
        <Box
          sx={{
            border: "1px solid lightgrey",
            padding: "20px",
            borderRadius: "15px",
          }}
        >
          <Typography variant="h6">Audience</Typography>
          <Box
            sx={{
              border: "1px solid lightgrey",
              borderRadius: "15px",
              maxWidth: "500px",
              padding: "10px",
              marginBottom: "10px",
            }}
          >
            <AudienceChart />
          </Box>
          <Box
            sx={{
              border: "1px solid lightgrey",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Audience Demographics
            </Typography>
            <Stack direction={"row"} justifyContent={"space-between"} gap={4}>
              <ContentEngagementBarGraph />
              <AudienceByGender />
            </Stack>
          </Box>
        </Box>
        <Box
          sx={{
            border: "1px solid lightgrey",
            padding: "20px",
            borderRadius: "15px",
          }}
        >
          <Typography variant="h6" gutterBottom>
            Content Performance
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <ContentViewBarGraph />
            </Grid>
            <Grid item xs={6}>
              <AverageWatchTimeChart />
            </Grid>
            <Grid item xs={6}>
              <EngagementRateChart />
            </Grid>
            <Grid item xs={6}>
              <ContentApprovalTimeGraph />
            </Grid>
          </Grid>
        </Box>
      </Stack>
    </div>
  );
};

export default Analytics;
